import React, { useState } from "react";

import Racheal from "../component/images/racheal.png";
import { Link } from "react-router-dom";
import { newTab } from "../App";
import Navbar from "./reusable/homepageNavbar";

import "boxicons";
import "./styles/home.css";

function Home() {
  const [state, setState] = useState(false);

  const handleToggle = () => {
    return setState(!state);
  };

  return (
    <div>
      <a className="h-menu" onClick={() => handleToggle()}>
        <box-icon name="menu" color="white"></box-icon>
      </a>
      {state === true ? <Navbar /> : ""}

      <header id="header" className="header-tops">
        <div className="container">
          <div className="row mt-5">
            <div className="col xl-6 col-lg-6 col-md-9 col-sm-12 sideone">
              <h1>
                <a href="/">Emily Timothy</a>
              </h1>
              {/* <!-- Uncomment below if you prefer to use an image logo --> */}
              {/* <a href="index.html" className="mr-auto"> */}
              {/* <img src={BImage} alt="" className="img-fluid" /> */}
              {/* </a> */}
              <h2>
                I'm a passionate <span>Software Developer</span>{" "}
              </h2>

              <nav className="nav-menu d-none d-lg-block">
                <ul>
                  <li className="active">
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/about">About</Link>
                  </li>
                  <li>
                    <Link to="/resume">Resume</Link>
                  </li>
                  <li>
                    <Link to="/services">Services</Link>
                  </li>
                  <li>
                    <Link to="/portfolio">Portfolio</Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
                </ul>
              </nav>
              {/* <!-- .nav-menu --> */}

              <div className="social-links">
                <Link onClick={() => newTab("https://twitter.com/EmIChEaLy")}>
                  <box-icon type="logo" name="twitter" color="white"></box-icon>
                </Link>

                <Link
                  onClick={() =>
                    newTab(
                      "https://m.facebook.com/home.php?paipv=0&eav=Afay4jGYtAJGT0GsW971ZCxLfwhXkMcJ19e23XlBxFDRm0RD1UsnYVjlcZbtpdqWGtM&_rdr&tbua=1"
                    )
                  }
                >
                  <box-icon
                    type="logo"
                    name="facebook"
                    color="white"
                  ></box-icon>
                </Link>

                <Link
                  onClick={() =>
                    newTab("https://www.instagram.com/emilychealy4/")
                  }
                >
                  <box-icon
                    type="logo"
                    name="instagram"
                    color="white"
                  ></box-icon>
                </Link>

                <Link
                  onClick={() =>
                    newTab("https://www.linkedin.com/in/emichealy/")
                  }
                >
                  <box-icon
                    type="logo"
                    name="linkedin"
                    color="white"
                  ></box-icon>
                </Link>

                <a href="mailto:emilychealy4@gmail.com, emilychealy4@gmail.com">
                  <box-icon name="mail-send" color="white"></box-icon>
                </a>
              </div>
            </div>
            <div className="col xl-6 col-lg-6 col-md-3 col-sm-12 img">
              <img src={Racheal} alt="" className="img-fluid" />
            </div>
          </div>
        </div>
      </header>

      {/* <!-- End Header --> */}
    </div>
  );
}

export default Home;
